import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Blog, { BlogDataType } from '@components/blog';

const query = graphql`
  query GuidesIndexQuery {
    prismicGuidesIndex {
      ...GuidesIndexData
    }
  }
`;

const GuidesIndexPage: React.FC = (): JSX.Element | null => {
  const data = useStaticQuery<{ prismicGuidesIndex: BlogDataType | null }>(query);
  const { prismicGuidesIndex } = data;

  if (!prismicGuidesIndex) {
    // Skip rendering if there is no guides index data available.
    return null;
  }

  return <Blog data={prismicGuidesIndex.data} postsType="guides_post" />;
};

export default GuidesIndexPage;
